import { useCallback, useRef, useState } from 'react';

import * as Yup from 'yup';
import { FormHandles } from '@unform/core';

import { useNotices } from 'hooks';
import { formatBirthDate, formatCpf } from 'utils/format';

import Modal from 'components/common/Modal';
import TextArea from 'components/common/Input/TextArea';
import InputFile from 'components/common/Input/InputFile';
import InputRadio from 'components/common/Input/InputRadio';
import InputWithLabel from 'components/common/Input/InputWithLabel';
import SelectWithLabel from 'components/common/Input/SelectWithLabel';

import * as S from './styles';

interface IModalSendRecipeProps {
  setShowModalSendRecipe(state: boolean): void;
}

export function ModalSendRecipe({
  setShowModalSendRecipe,
}: IModalSendRecipeProps) {
  const { addNotices } = useNotices();

  const formSendRecipe = useRef<FormHandles>(null);

  const [formattedCPF, setFormattedCPF] = useState('');
  const [userIsPatient, setUserIsPatient] = useState(true);
  const [formattedBirthDate, setFormattedBirthDate] = useState('');
  const [formattedRecipeDate, setFormattedRecipeDate] = useState('');

  const handleSendRecipe = useCallback(() => {
    /* TODO CRIAR VALIDAÇÃO DE FORM PARA ENVIO DE RECEITA, PARA CASO FUTURAMENTE PRECISAR, JÁ ESTIVER PRONTO */
  }, []);

  return (
    <div className="modal-send-recipe">
      <Modal onClose={() => setShowModalSendRecipe(false)} withScroll>
        <S.Container
          ref={formSendRecipe}
          className="modal-send-recipe-content"
          onSubmit={handleSendRecipe}
        >
          <h4>Incluir receita</h4>

          <div className="group-items inputs-radio">
            <InputRadio
              name="souPaciente"
              label="Sou paciente"
              checked={userIsPatient}
              onClick={() => setUserIsPatient(true)}
              readOnly
            />
            <InputRadio
              name="nãoSouPaciente"
              label="Não sou paciente"
              checked={!userIsPatient}
              onClick={() => setUserIsPatient(false)}
              readOnly
            />
          </div>

          {!userIsPatient && (
            <>
              <div className="group-items two-columns">
                <InputWithLabel
                  name="name"
                  label="Nome do paciente"
                  placeholder="Nome do paciente"
                  required
                />

                <InputWithLabel
                  name="birthDate"
                  label="Data de nascimento"
                  placeholder="Data de nascimento"
                  value={formattedBirthDate}
                  onChange={e => formatBirthDate(e, setFormattedBirthDate)}
                  required
                />
              </div>

              <div className="group-items">
                <InputWithLabel
                  name="rg"
                  label="RG"
                  placeholder="RG"
                  required
                />

                <SelectWithLabel
                  name="gender"
                  label="Sexo"
                  placeholder="Sexo"
                  required
                  options={[
                    {
                      label: 'Masculino',
                      value: 'M',
                    },
                    {
                      label: 'Feminino',
                      value: 'F',
                    },
                  ]}
                />
              </div>
            </>
          )}

          <div className="group-items two-columns">
            <InputWithLabel
              type="email"
              name="email"
              label="Email"
              placeholder="Email"
              required
            />

            <InputWithLabel
              name="cpf"
              label="CPF"
              placeholder="CPF"
              value={formattedCPF}
              onChange={e => formatCpf(e, setFormattedCPF)}
              required
            />
          </div>

          <div className="group-items">
            <InputWithLabel
              name="recipeDate"
              label="Data da receita"
              placeholder="Data da receita"
              value={formattedRecipeDate}
              onChange={e => formatBirthDate(e, setFormattedRecipeDate)}
              required
            />

            <InputWithLabel
              type="number"
              name="quantity"
              label="Quantidade"
              placeholder="Quantidade"
              required
            />
          </div>

          <InputWithLabel
            name="doctorName"
            label="Nome do médico"
            placeholder="Nome do médico"
            readOnly
          />

          <div className="group-items">
            <SelectWithLabel
              name="responsible"
              label="Orgão"
              required
              options={[
                {
                  label: 'CRM',
                  value: 'CRM',
                },
                {
                  label: 'CRMV',
                  value: 'CRMV',
                },
                {
                  label: 'CRO',
                  value: 'CRO',
                },
              ]}
            />

            <SelectWithLabel
              name="state"
              label="UF"
              required
              options={[
                {
                  label: 'Minas Gerais',
                  value: 'MG',
                },
                {
                  label: 'São Paulo',
                  value: 'SP',
                },
                {
                  label: 'Rio de Janeiro',
                  value: 'RJ',
                },
              ]}
            />

            <InputWithLabel
              name="registrationNumber"
              label="Número da inscrição"
              placeholder="CRM/CRMV/CRO"
              required
            />
          </div>

          <TextArea
            name="obs"
            label="Observação"
            placeholder="Observação"
            required
          />

          <InputFile
            name="file"
            label="Arquivo"
            icon="paper-clip.png"
            position="left"
            size={3000000}
            accept="application/pdf,.jpeg,.png"
            required
          />

          <button
            className="modal-button"
            onClick={() => {
              setShowModalSendRecipe(false);
              addNotices({
                type: 'success',
                messages: ['Receita enviada com sucesso!'],
              });
            }}
          >
            Enviar
          </button>

          <div className="info-about-file">
            <ul>
              <li>Arquivos JPEG, PNG e PDF</li>
              <li>Máximo de 3MB</li>
              <li>Todas as informações devem estar legíveis</li>
            </ul>
          </div>
        </S.Container>
      </Modal>
    </div>
  );
}
